import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Select from 'react-select';
import Moment from "moment";
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import * as moment from 'moment';

const modeloDatos = {
    cxcID: 0, 
    empresaID: "PR",
    clienteID: 1,
    nombreCliente: "",
    rncCliente: "",
    ncfCliente: "",
    vendedor: "",
    comentario: "",
    itbis:0.00,
    subTotal: 0.00,
    formaPago: "",
    total: 0.00,
  
    creadoPor: "",
    fechaCreado: new Date,
    fechaFactura: new Date,
    estatus: 0,
   pagado:0.00
}

let movimiento = "";
let options1 = [];
const MovimientoAlmacen = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [VerImpresion, setVerImpresion] = useState(false);
    const [VerFactura, setVerFactura] = useState(false);
    const [VerRecibo, setVerRecibo] = useState(false);
    const [DRecibo, setDRecibo] = useState([]);
    const [Recibo, setRecibo] = useState("");
    const [PagoModal, setPagoModal] = useState(false);
    const [EstadoModal, setEstadoModal] = useState(false);
    const [ver, setVer] = useState(true);
    const [Listado1, SetListado1] = useState([]);
    const [busqueda, setbusqueda] = useState("");
    const [Pagado, setPagado] = useState(0.00);
    const [Comentario, setComentario] = useState(0.00);
    const [Empresa, SetEmpresa] = useState([]);

    const [ListadoLineas, SetListadoLineas] = useState([]);
    const [ListadoTrans, SetListadoTrans] = useState([]);

    const obtenerDatosEmpresa = async (e) => {
        let response = await fetch(Api + "Administracion/ListaEmpresas/" + e);
        if (response.ok) {
            let data = await response.json();
            var d = data.filter(x => x.empresaID == e).map(e => e)
            SetEmpresa(d[0])
        }
    }

    const handleChange = (e) => {

        setTabla({
            ...tabla,
            [e.target.name]: e.target.value
        })
    }
    const handleChange1 = (e) => {

        if (e.target.name == "pagado" && e.target.value > (tabla.total - tabla.pagado)) {
            Swal.fire(
                'EL MONTO PAGADO!',
                'NO PUEDE SER MAYOR AL ENDEUADADO',
                'error'
            )
            e.target.value =0
        }
       setPagado(e.target.value)
    }
    const handleChange2 = (e) => {
        setTabla({
            ...tabla,
            ["clienteID"]: e.value, ["nombreCliente"]: e.nombreCliente, ["rncCliente"]: e.rncCliente, ["vendedor"]: e.vendedor
        })
    }
    const obtenerDatosCliente = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaClientes");

        if (response.ok) {
            let data = await response.json()
            options1 = []
            data.map(x => {
                options1.push({ value: x.clienteID, label: x.descripcion, nombreCliente: x.descripcion, rncCliente: x.rnc })
            })
           
        }
    }

    const money = (v) => {

        let locale = "es-DO"


        const n = Number.isFinite(+v) ? +v : 0;

        let out = new Intl.NumberFormat(locale, {
            style: "currency",
            currency: "DOP",
            currencyDisplay: "symbol", // a veces algunos locales rinden "US$"
        }).format(n);
        // Quita cualquier “US$” o “USD ” que pudiera aparecer
        out = out.replace(Listado.moneda + "$");
        return out.trim();

    };
    const onChange = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
        console.log(e);
        var searchData = l.filter((item) => {
            if (
                (item.nombreSuplidor + item.rncSuplidor)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };

   
    const obtenerDatos = async () => {
        let response = await fetch(Api + "CXC/ListaFactura/a");
        if (response.ok) {
            let data = await response.json()
            SetListado1(data)
            if (pendiente) {
                SetListado(data)
            }
            setPendiente(false)
        }
    }
    

   

   
    useEffect(() => {
        obtenerDatos();
    
    })
    
   
    useEffect(() => {
      
        obtenerDatosCliente()
    },[])
    
   
   
    const guardarCambios = async () => {
      

        let response;
        if (tabla.cxcID == 0) {
            console.log(tabla)
            response = await fetch(Api + "CXC/GuardarRegistroCXC", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

        } else {
            response = await fetch(Api + "CXP/EditarRegistroCXC", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            let data = await response.json()
            obtenerDatos();
            setTabla(modeloDatos)
            tabla.movimientoAlmacenID = data.movimientoAlmacenID;
            setVer(false)
            cerrarModal()
            obtenerDatos()
            
        //    setVerModal(!verModal);
           
        } else {
            alert("error al guardar")
        }

    }

    const procesarPago = async () => {
        tabla.pagado = parseFloat(tabla.pagado)
        let response = await fetch(Api + "CXC/ProcesarPago/" + tabla.cxcID+"/"+ Pagado+"/ad/"+Comentario);

        if (response.ok) {
            let data = await response.json()
            setPendiente(true)
          setPagado(0.00)
           
setPagoModal(false)
        }
        obtenerDatos()
    }
    const Pagar = (data) => {
        setTabla(data);
        setPagoModal(true)
    }

    const abrirEditarModal = (data, v) => {
        setVer(v);
        setTabla(data);
       obtenerDatosLineas(data.noFactura)
     
        setVerModal(!verModal);
    }
    const abrirImpresion = (data, v) => {
        
       setVerImpresion(v);
        setTabla(data);
       obtenerDatosLineas(data.noFactura)
        obtenerDatosTrans(data.noFactura)
        obtenerDatosEmpresa(data.empresaID)
    
    }
    const ImpresionRecibo = (data, v) => {
        setRecibo(data.cxcTransID)
        setDRecibo([data])
        setVerRecibo(true)
    
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
        setVerImpresion(false)
        setVerFactura(false)
        setVerRecibo(false)
    }
    const obtenerDatosLineas = async (pl) => {
        let response = await fetch(Api + "VentasTrans/ListaPedidoVentasLineasF/" + pl);
        if (response.ok) {
            let data = await response.json()
            SetListadoLineas(data)

        }
    }

      const obtenerDatosTrans = async (pl) => {
          let response = await fetch(Api + "CXC/ListaRegistroCXCTrans/" + pl);
        if (response.ok) {
            let data = await response.json()
            SetListadoTrans(data)


        }
    }

    const columns = [
        {
            name: 'Factura',
            selector: row => row.noFactura,
            sortable: true,
        },
        {
            name: 'Cliente',
            selector: row => row.nombreCliente,
            sortable: true,
        },
        {
            name: 'Monto',
            selector: row => formatoMoneda(row.total, 'USD', 'en-US'),
            sortable: true,
        }, {
            name: 'Pagado',
            selector: row => formatoMoneda(row.pagado, 'USD', 'en-US'),
            sortable: true,
        },
        {
            name: 'Debe',
            selector: row => formatoMoneda((row.total - row.pagado), 'USD', 'en-US'),
            sortable: true,
        },  {
            name: 'Fecha',
            selector: row => (Moment(row.fechaFactura).format("DD/MM/YYYY")),
            sortable: true,
        },
        {
            name: 'Estado',
            selector: row => row.estatus,
            sortable: true,
            cell: row => {
                let clase;
                clase = row.estatus ? "badge badge-info p-2" : "badge badge-danger p-2"
                return (
                    <span className={clase}>{row.estatus ? "PAGO" : "PENDIENTE"}</span>
                )
            }
        },
    
        {
            name: '',
            cell: row => (
                <>
                    {(row.estatus == 0)?
                     <>   <Button color="primary" size="sm" className="mr-2"
                            onClick={() => abrirEditarModal(row)}
                        >
                            <i className="fas fa-pen-alt"></i>
                        </Button> 
                        <Button color="success" size="sm" className="mr-2"
                            onClick={() => Pagar(row)}
                        >
                                <i className="fas fa-money-bill"></i>
                            </Button>
                            <Button color="primary" size="sm" className="mr-2"
                                onClick={() => abrirImpresion(row, true)}
                            >
                                <i className="fas fa-print"></i>
                            </Button>
                        </> :

                        <Button color="primary" size="sm" className="mr-2"
                            onClick={() => abrirEditarModal(row, true)}
                        >
                            <i className="fas fa-eye"></i>
                        </Button>
             
                    }
                  
                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    // Crear una función para formatear como moneda
    function formatoMoneda(valor, moneda = 'USD', localizacion = 'en-US') {
        const formatter = new Intl.NumberFormat(localizacion, {
            style: 'currency',
            currency: moneda
        });
        return formatter.format(valor);
    }

    const [menuPosition, setMenuPosition] = useState(false);

    const handleContextMenu = (event) => {
        event.preventDefault();
        setMenuPosition({
            x: event.pageX,
            y: event.pageY,
        });
    };


    const generarEstadoCuenta = () => {
        const cuentas = {};

        Listado1.forEach(factura => {
            if (!cuentas[factura.clienteID]) {
                cuentas[factura.clienteID] = {
                    cliente: factura.nombreCliente,
                    facturas: [],
                    total: 0,
                    pagado: 0
                };
            }

            const pendiente = factura.total - factura.pagado;

            cuentas[factura.clienteID].facturas.push({
                noFactura: factura.noFactura,
                nombreCliente: factura.nombreCliente,
                fecha: Moment(factura.fechaFactura).format("DD/MM/YYYY"),
                total: factura.total,
                pagado: factura.pagado,
                pendiente
            });

            cuentas[factura.clienteID].total += factura.total;
            cuentas[factura.clienteID].pagado += factura.pagado;
        });

        return Object.values(cuentas);
    };

    let taxRate = 0.18;         // ITBIS 18%

    const [imageSrc, setImageSrc] = useState("");
    const percentLabel = `${Math.round(taxRate * 100)}%`;

    const estadoCuenta = generarEstadoCuenta();
    const styles = `
    :root{
      --primary:#0d6efd; --text:#1f2937; --muted:#6b7280;
      --border:#e5e7eb; --bg:#ffffff; --stripe:#f9fafb;
    }
    *{box-sizing:border-box}
    body{ -webkit-print-color-adjust:exact; print-color-adjust:exact; }
    .page{ max-width:900px; margin:24px auto; padding:28px; background:#fff; border:1px solid var(--border); border-radius:12px; color:var(--text); font:14px/1.5 system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,'Helvetica Neue',Arial; }
    header{ display:flex; align-items:center; gap:18px; border-bottom:2px solid var(--border); padding-bottom:16px; }
    .logo{ width:90px; height:90px; border:1px dashed var(--border); display:flex; align-items:center; justify-content:center; border-radius:10px; font-weight:700; color:var(--muted); background:linear-gradient(180deg,#fff,#f8fafc); overflow:hidden; }
    .logo img{ width:100%; height:100%; object-fit:contain; }
    .company{ flex:1; }
    .company h1{ margin:0; font-size:22px; letter-spacing:.3px; }
    .company p{ margin:.2rem 0; color:var(--muted); }
    .meta{ text-align:right; min-width:240px; }
    .meta h2{ margin:0; color:var(--primary); font-size:20px; }
    .meta .code{ font-weight:700; }
    .grid{ display:grid; grid-template-columns:1fr 1fr; gap:14px; margin:16px 0 8px; }
    .card{ border:1px solid var(--border); border-radius:10px; padding:12px 14px; background:#fff; }
    .card h3{ margin:0 0 6px; font-size:14px; color:#111827; }
    .card p{ margin:.2rem 0; color:var(--muted); }
    table{ width:100%; border-collapse:collapse; margin-top:14px; font-size:13px; border:1px solid var(--border); border-radius:10px; overflow:hidden; }
    thead th{ text-align:left; background:#f3f4f6; color:#111827; font-weight:600; padding:10px; border-bottom:1px solid var(--border); }
    tbody td{ padding:9px 10px; border-bottom:1px solid var(--border); vertical-align:top; }
    tbody tr:nth-child(odd){ background:var(--stripe); }
    tfoot td{ padding:8px 10px; border-top:1px solid var(--border); }
    .right{text-align:right}
    .totals{ margin-top:10px; display:grid; grid-template-columns:1fr 320px; gap:12px; align-items:start; }
    .summary{ border:1px solid var(--border); border-radius:10px; padding:12px 14px; background:#fff; }
    .summary .row{ display:flex; justify-content:space-between;  border-bottom:1px dashed var(--border);flex-wrap: nowrap; }
    .summary .row:last-child{ border-bottom:none; }
    .summary .row.total{ font-size:16px; font-weight:800; color:#111827; }
    .notes{ margin-top:14px; border:1px solid var(--border); border-radius:10px; padding:12px 14px; background:#fff; color:var(--muted); }
    .sign{ display:grid; grid-template-columns:1fr 1fr; gap:18px; margin-top:30px; }
    .sign .line{ border-top:1px solid var(--border); padding-top:8px; text-align:center; color:var(--muted); }
    .actions{ display:flex; gap:8px; justify-content:flex-end; margin-top:10px; }
    .btn{ appearance:none; border:1px solid var(--border); background:#fff; padding:8px 12px; border-radius:8px; cursor:pointer; }
    .btn.primary{ background:var(--primary); border-color:var(--primary); color:#fff; }
    @media print{
      .page{ border:none; border-radius:0; padding:0; margin:0; }
      .actions{ display:none !important; }
      thead{ display:table-header-group; }
      tbody{ display:table-row-group; }
    }
  `;




    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de registros cuenta por pagar
                </CardHeader>
                <CardBody>
                    <Row><Col md={2}>    <Button color="success" size="sm"
                    onClick={() => setVerModal(!verModal)}
                    >Nueva Cuenta por cobrar</Button>
                    </Col>
                        
                <Col md={4}>    <Input type="search" name="busqueda" onChange={(e) => onChange(e)} placeholder="Buscar  " ></Input> </Col>
                        <Col md={2}>    <Button color="success" size="sm"
                            onClick={() => setEstadoModal(!EstadoModal)}
                        >Estado Cuenta</Button>
                        </Col>
                    </Row>  
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado.filter(x => x.estatus == 0).map(e =>e)}
                      progressPending={pendiente}
                       pagination
                      paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal className="modal-preguntas" isOpen={verModal}>
                <ModalHeader className="modal-header1">
                  
                    <div class="box">
                        <div>   Movimiento de articulo en Almacen </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Cliente</Label>
                                {/*<Input bsSize="sm" type={"select"} name="suplidorID" onChange={handleChange} value={tabla.suplidorID} className="form-control"  >*/}
                                {/*     <option value={0}>Seleccionar</option>*/}
                                {/*    {*/}
                                {/*       ListadoSuplidor.map((item) => (<option key={item.suplidorID} value={item.suplidorID}>{item.descripcion}</option>))*/}
                                {/*    }*/}
                                {/*</Input>*/}
                                <Select
                                    name={"clienteID"}
                                    defaultValue={options1.filter(x => x.value == tabla.clienteID)[0]}
                                    onChange={handleChange2}
                                    options={options1}
                                />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>RNC</Label>
                                <Input bsSize="sm" name="rncCliente" onChange={handleChange} value={tabla.rncCliente} />
                            </FormGroup></Col>
                        <Col md={6}>
                            <FormGroup>

                                <Label>NCF</Label>
                                <Input bsSize="sm" name="ncfCliente" onChange={handleChange} value={tabla.ncfCliente} />
                            </FormGroup></Col>
                       

                        <Col md={3}>
                            <FormGroup>
                                <Label>Vendedor</Label>
                                <Input bsSize="sm" name="vendedor" onChange={handleChange} value={tabla.vendedor} />

                                {/*<Input bsSize="sm" type={"select"} name="tipoTransaccionID" onChange={handleChange} value={tabla.tipoTransaccionID} className="form-control" >*/}
                                {/*    <option value={'+'}>Entrada</option>*/}
                                {/*    <option value={'-'}>Salida</option>*/}
                                   

                                {/*</Input>*/}
                            </FormGroup>                        </Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Comentario</Label>
                                <Input bsSize="sm" name="comentario" onChange={handleChange} value={tabla.comentario} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>ITBIS</Label>
                                <Input bsSize="sm" type="number" name="itbis" onChange={handleChange} value={tabla.itbis} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>SupTotal</Label>
                                <Input bsSize="sm" type="number" name="subTotal" onChange={handleChange} value={tabla.subTotal} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Total</Label>
                                <Input bsSize="sm" type="number" name="total" onChange={handleChange} value={tabla.total} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Forma de Pago</Label>
                                <Input bsSize="sm" name="formaPago" onChange={handleChange} value={tabla.formaPago} />
                            </FormGroup></Col>
                    
                    <Col md={3}>
                            <FormGroup>

                                <Label>Fecha Factura</Label>
                                <Input bsSize="sm" type="date" name="fechaFactura" onChange={handleChange} value={Moment(tabla.fechaFactura).format('YYYY-MM-DD')} />
                            </FormGroup></Col>
                    </Row>
                    <div>
                        <Row hidden={ver}>
                        <Col md={6}>
                        <FormGroup>
                        <Label> Articulo</Label>
                                  
                            </FormGroup>
                        </Col>
                       
                       
                    </Row>
                    
                        <Row>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Descripción</th>
                                        <th className="right" style={{ width: 90 }}>Cant.</th>
                                       
                                        <th className="right" style={{ width: 120 }}>Precio Unit.</th>
                                        <th className="right" style={{ width: 90 }}>% Desc.</th>
                                        <th className="right" style={{ width: 130 }}>Importe</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {ListadoLineas.map((it, idx) => {
                                        const qty = Number(it.cantidad || 0);
                                        const price = Number(it.precio || 0);
                                        const disc = Number(it.discountPercent || 0);
                                        const line = qty * price;
                                        const lineDisc = (line * disc) / 100;
                                        const totalLine = line - lineDisc;
                                        return (
                                            <tr key={idx}>
                                                <td>{it.descripcionArticulo}</td>
                                                <td className="right">{qty}</td>
                                                <td className="right">{formatoMoneda(price, 'USD', 'en-US')}</td>
                                                <td className="right">{disc}</td>
                                                <td className="right">{formatoMoneda(totalLine, 'USD', 'en-US')}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                    </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button hidden={!ver } size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                      onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*Procesar pago*/}
            <Modal isOpen={PagoModal}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Cobro de Factura </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setPagoModal(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        
                         <p>   Suplidor: <b>{tabla.nombreSuplidor}</b>    </p>
                        <p>   Monto Pendiente de pago: <b>{formatoMoneda((tabla.total - tabla.pagado), 'USD', 'en-US')}</b>    </p>
                    
                        <Col >
                            <FormGroup>
                                <Label>Monto a Pagar</Label>
                                <Input bsSize="sm" name="pagado" onChange={handleChange1} value={Pagado } />
                            </FormGroup>
                        </Col>
                        <Col >
                            <FormGroup>
                                <Label>Comentario</Label>
                                <Input bsSize="sm" onChange={(e) => setComentario(e.target.value)} value={Comentario } />
                            </FormGroup>
                        </Col>
                      
                    </Row>
                </ModalBody>
                <ModalFooter>
                    { (Pagado  > 0)&&
                    <Button size="sm" color="primary"
                        onClick={procesarPago}
                    >Procesar Pago</Button> }
                    <Button size="sm" color="danger"
                        onClick={() => setPagoModal(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            <Modal className="modal-preguntas" isOpen={EstadoModal}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Estado </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setEstadoModal(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>

            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Estado de Cuenta por Cliente
                </CardHeader>
                <CardBody>
                            {estadoCuenta.map((cliente, index) => (
                        <div key={index} style={{ marginBottom: "2rem" }}>
                            <h5>{cliente.cliente}</h5>
                            <table className="table table-bordered table-sm">
                                <thead className="thead-light">
                                    <tr>
                                        <th>Factura</th>
                                        <th>Nombre</th>
                                        <th>Fecha</th>
                                        <th>Total</th>
                                        <th>Pagado</th>
                                        <th>Pendiente</th>
                                    </tr>
                                </thead>
                                <tbody>
                                            {cliente.facturas.filter(x => x.pendiente > 0).map((f, i) => (
                                        <tr key={i}>
                                            <td>{f.noFactura}</td>
                                            <td>{f.nombreCliente}</td>
                                            <td>{f.fecha}</td>
                                            <td>{formatoMoneda(f.total)}</td>
                                            <td>{formatoMoneda(f.pagado)}</td>
                                            <td>{formatoMoneda(f.pendiente)}</td>
                                        </tr>
                                    ))}
                                    <tr className="table-secondary font-weight-bold">
                                        <td >Totales</td>
                                        <td colSpan="2">{cliente.facturas.length}</td>
                                        <td>{formatoMoneda(cliente.total)}</td>
                                        <td>{formatoMoneda(cliente.pagado)}</td>
                                        <td>{formatoMoneda(cliente.total - cliente.pagado)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    ))}
                </CardBody>
            </Card>
        </ModalBody >
            <ModalFooter>
                
                <Button size="sm" color="danger"
                        onClick={() => setEstadoModal(false)}
                >Cerrar</Button>
            </ModalFooter>
            </Modal >

            <Modal className="modal-preguntas" isOpen={VerFactura}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Estado </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setVerImpresion(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>

            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                 Listado de recibos
                </CardHeader>
                <CardBody>
                            {estadoCuenta.map((cliente, index) => (
                        <div key={index} style={{ marginBottom: "2rem" }}>
                            <h5>{cliente.cliente}</h5>
                            <table className="table table-bordered table-sm">
                                <thead className="thead-light">
                                    <tr>
                                        <th>Factura</th>
                                        <th>Nombre</th>
                                        <th>Fecha</th>
                                        <th>Total</th>
                                        <th>Pagado</th>
                                        <th>Pendiente</th>
                                    </tr>
                                </thead>
                                <tbody>
                                            {cliente.facturas.filter(x => x.pendiente > 0).map((f, i) => (
                                        <tr key={i}>
                                            <td>{f.noFactura}</td>
                                            <td>{f.nombreCliente}</td>
                                            <td>{f.fecha}</td>
                                            <td>{formatoMoneda(f.total)}</td>
                                            <td>{formatoMoneda(f.pagado)}</td>
                                            <td>{formatoMoneda(f.pendiente)}</td>
                                        </tr>
                                    ))}
                                    <tr className="table-secondary font-weight-bold">
                                        <td >Totales</td>
                                        <td colSpan="2">{cliente.facturas.length}</td>
                                        <td>{formatoMoneda(cliente.total)}</td>
                                        <td>{formatoMoneda(cliente.pagado)}</td>
                                        <td>{formatoMoneda(cliente.total - cliente.pagado)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    ))}
                </CardBody>
            </Card>
        </ModalBody >
            <ModalFooter>
                
                <Button size="sm" color="danger"
                        onClick={() => setEstadoModal(false)}
                >Cerrar</Button>
            </ModalFooter>
            </Modal >



            <Modal className="modal-preguntas" isOpen={VerImpresion}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Recibo Pagados </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setVerImpresion(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div>
                        {tabla.nombreCliente }
                        {tabla.noFactura }
                        {tabla.fechaFactura }
                        {tabla.pagado }
                        {tabla.total }
                        {tabla.estatus }
                    </div>

                    <table>

                        <tr>
                            <th>No Recibo</th>
                            <th>Fecha</th>
                            <th>Pagado</th>
                            <th>Comentario</th>
                        </tr>

                        {ListadoTrans.map(x => (
                            <tr>
                                <td>{x.cxcTransID}</td>

                                <td>{moment(x.fechaCreado).format("DD/MM/YYYY")}</td>
                                <td>{formatoMoneda(x.pagado)}</td>
                                <td>{ x.comentario}</td>
                                <td><Button onClick={() => ImpresionRecibo(x) } ><i className="fas fa-print" ></i></Button></td>
                            </tr>

                        )) }
                    </table>

        </ModalBody >
            <ModalFooter>
                
                <Button size="sm" color="danger"
                        onClick={() => cerrarModal()}
                >Cerrar</Button>
            </ModalFooter>
            </Modal >

            {/*/Imprimir Recibo*/}

            <Modal className="modal-preguntas" isOpen={VerRecibo}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Recibo Pagados </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setVerRecibo(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div onContextMenu={handleContextMenu}   >
                        <div class="printArea" style={{ backgroundColor: "none", marginLeft: "50px", marginTop: "50px" }} >
                            <style>{styles}</style>

                            <div className="page">
                                <div className="actions">
                                    <button className="btn" onClick={() => window.print()}>Imprimir</button>
                                </div>
                                <header>
                                    <div className="logo">
                                        <img src={imageSrc} alt="Logo" style={{ width: '200px', height: '150px' }} />
                                    </div>
                                    <div className="company" >
                                        <h2 style={{ textAlign: "left" }} >{Empresa.descripcion}</h2>
                                        <p>RNC: {Empresa.rnc}</p>
                                        <p>{Empresa.direccion}</p>
                                        <p>Tel: {Empresa.telefono} · Email: {Empresa.email}</p>
                                    </div>
                                    <div className="meta">
                                        <h2>Recibo</h2>

                                        <div><b>Impreso</b></div>
                                        <div><b>Fecha:</b>{moment(new Date).format("DD/MM/YYYY")}</div>
                                        <div><b>Hora:</b>{moment(new Date).format("HH:mm:SS")}</div>


                                    </div>
                                </header>

                                <div className="grid">
                                    <div className="card">
                                        <h3>Cliente</h3>
                                        <div><strong>{tabla.nombreCliente}</strong></div>
                                        <div>RNC/Cédula: {tabla.rnc}</div>
                                        <div>Contacto: </div>
                                        {/*  <div>Tel/Email: {Listado.telefono + " / " + ListadoClientes.correo}</div>
                                        <div>Dirección: {ListadoClientes.direccion}</div>*/}
                                        <div>Vendedor: </div>
                                    </div>
                                    <div className="card">
                                        <h3>Recibo de Pago</h3>
                                        {/* <div>{SN}</div>*/}
                                          <div ><b>Recibo No:</b>{Recibo}</div>
                                          <div ><b>Factura No:</b>{tabla.noFactura}</div>
                                        <div><b>Orden No:</b>{tabla.noPedido}</div>
                                        <div><b>Fecha:</b>{moment(DRecibo[0]?.fechaCreado).format("DD/MM/YYYY")}</div>
                                
                                        <div><b>Moneda:</b>{Listado.moneda} </div>
                                    </div>
                                </div>

                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ width: 40 }}>#</th>
                                            <th>Descripción</th>
                                          
                                            <th className="center" style={{ width: 110 }}>Balance Resta</th>
                                            <th className="right" style={{ width: 130 }}>Pagado</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {DRecibo.map((it, idx) => {
                                            const qty = Number(it.cantidad || 0);
                                            const price = Number(it.precio || 0);
                                    
                                            return (
                                                <tr key={idx}>
                                                    <td>{idx + 1}</td>
                                                    <td className="left">{it.comentario}</td>
                                                 
                                                    <td className="right">{money(it.balance)}</td>
                                                    <td className="right">{formatoMoneda(it.pagado)}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>

                                <div className="totals">
                                    <div></div>
                                
                                </div>

                                <div className="notes">
                                    <strong>Notas / Condiciones:</strong>
                                    {Listado.comentario}
                                </div>

                                <div className="sign">
                                    <div style={{
                                        //borderTop: '2px solid',
                                        width: '30%',
                                        textAlign: 'center'
                                    }}>
                                        <img class="card-img-top" src="./imagen/LogoEmpresa/Firma.png" style={{ width: '200px', height: '90px', borderBottom: '2px solid' }} />
                                        Firma y sello 
                                    </div>

                                    <div className="line">Aceptación del cliente</div>
                                </div>


                            </div>
                        </div>
                        </div>


        </ModalBody >
            <ModalFooter>
                
                <Button size="sm" color="danger"
                        onClick={() => cerrarModal()}
                >Cerrar</Button>
            </ModalFooter>
            </Modal >
        </>
        )

}
export default MovimientoAlmacen;